import apiService from '../apiService';

const baseUrl = `${window._env_.CALLBACKS_API_DOMAIN}`;

const getPrices = () => {
  const url = `${baseUrl}/v1/plans/business`;
  return apiService.get(url);
};

const postUpgrade = (plan) => {
  const url = `${baseUrl}/v1/payments/checkout/${plan}`;
  return apiService.post(url);
};

const getFlexiPlanData = () => {
  const url = `${baseUrl}/v1/plans/flexi`;
  return apiService.get(url);
};

const postFlexiPlanUpgrade = (planId, quantity) => {
  const url = `${baseUrl}/v1/payments/checkout/${planId}`;
  // redirectUrl can be handled by the backend - we can delete the param when BE part is fixed
  return apiService.post(url, { quantity, redirectUrl: '' });
};

export { getPrices, postUpgrade, getFlexiPlanData, postFlexiPlanUpgrade };
